import { useIsSocialStarter } from './useIsSocialStarter';
import { useCustomerInfo, useIsTrialer } from '../queries';

export type UseRemove6MoPrepayFacadeReturn = ReturnType<typeof useRemove6MoPrepayFacade>;

export const useRemove6MoPrepayFacadeDefaultReturn = {
  isLoading: false,
  error: null,
  isError: false,
  data: {
    isEnabled: false,
  },
};

export const useRemove6MoPrepayFacade = ({
  isMobile,
  isMobileLoading,
}: {
  isMobile: boolean;
  isMobileLoading: boolean;
}) => {
  const isTrialer = useIsTrialer();
  const { isSocialStarter, isLoading: isSocialStarterLoading, error: socialStarterError } = useIsSocialStarter();
  const customerInfo = useCustomerInfo();

  const error = isTrialer.error || socialStarterError || customerInfo.error;
  const isLoading = isMobileLoading || isTrialer.isLoading || isSocialStarterLoading || customerInfo.isLoading;

  const isUs = customerInfo.data?.isUs() ?? false;
  const isEnabled = !isLoading && !error && !isMobile && !isSocialStarter && !!isTrialer.data && isUs;

  return {
    isLoading,
    isError: !!error,
    error,
    data: {
      isEnabled,
    },
  };
};
